export const ROUTES = {
  FAQ: '/faq',
  HOME: '/',
  LOBBY: '/lobby',
  EXPLORE_GAMES: '/explore-games',
  ROOM: '/room',
  STREAM: '/stream',
  VERIFY: '/verify',
  NFTS: '/nfts',
  LEADERBOARD: '/leaderboard',
  DAILY_QUESTS: '/daily-quests',
  PRIZE_BOX: '/prize-box',
};
